module.exports = __webpack_public_path__ + "media/images/weather/500_day-ae39b0b010f945e64eff04bad85cc4f5.png";